import { render, staticRenderFns } from "./ScheduleDemo.vue?vue&type=template&id=dadb4526&scoped=true&"
import script from "./ScheduleDemo.vue?vue&type=script&lang=ts&"
export * from "./ScheduleDemo.vue?vue&type=script&lang=ts&"
import style0 from "./ScheduleDemo.vue?vue&type=style&index=0&id=dadb4526&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dadb4526",
  null
  
)

export default component.exports